import { useAPI } from '@axo/shared/data-access/provider';
import { useMutation } from 'react-query';
import { loan_application_api } from '@axo/shared/data-access/api';

export function useCheckApplicationValidation() {
  const api = useAPI();

  return useMutation({
    mutationFn: loan_application_api.validateApplication(api),
  });
}
